import { APIGet, APIPost, APIPut, APIDelete, APIUrl, AdminType, StatusCode } from "api/protocols";
import { CancelToken } from "axios";
import { TTeesheetPricingSheet } from "redux/reducers/models/teesheet";

interface IGetPricingSheet {
  id?: string;
  extended?: boolean;
}

interface IPostPricingSheet {
  title: string;
  day_of_week: string;
  start_time: string;
  end_time: string;
  course_id: number;
  application: string;
  start_date: string;
  end_date: string;
}

interface IPricingSheetRes {
  status: StatusCode;
  data: any;
}

interface IDuplicatePricingSheet {
  day_of_week?: string;
  pricing_sheet_ids: Array<number>;
  course_id: number;
}

interface IDeletePricingSheet {
  id: Array<number>;
}

export type TPutPricingSheetBulkUpdate = {
  pricing_sheet_ids: number[];
  start_date?: string;
  end_date?: string;
  start_time?: string;
  end_time?: string;
  day_of_week?: string;
  course_id?: number;
  variant_ids?: number[];
};

// GET Cart
// Retrieve a list of customers
// memberships: boolean
export async function GetPricingSheet(params: IGetPricingSheet, useGlobalLoader: boolean, token?: CancelToken) {
  return await APIGet<TTeesheetPricingSheet[]>(
    APIUrl(AdminType.FacilityAdmin, "/tee-sheet/pricing-sheet"),
    params,
    useGlobalLoader,
    token,
  );
}

export async function PostPricingSheet(params: IPostPricingSheet, useGlobalLoader: boolean): Promise<IPricingSheetRes> {
  return await APIPost(APIUrl(AdminType.FacilityAdmin, "/tee-sheet/pricing-sheet"), params, useGlobalLoader);
}

export async function PutPricingSheet(params: any, useGlobalLoader: boolean): Promise<IPricingSheetRes> {
  return await APIPut(APIUrl(AdminType.FacilityAdmin, "/tee-sheet/pricing-sheet"), params, useGlobalLoader);
}

export async function PutPricingSheetBulkUpdate(params: TPutPricingSheetBulkUpdate, useGlobalLoader: boolean) {
  return await APIPut<{ updated_count: number }>(
    APIUrl(AdminType.FacilityAdmin, "/tee-sheet/pricing-sheet/bulk-update"),
    params,
    useGlobalLoader,
  );
}

export async function PostPricingSheetProduct(params: any, useGlobalLoader: boolean): Promise<IPricingSheetRes> {
  return await APIPost(APIUrl(AdminType.FacilityAdmin, "/tee-sheet/pricing-sheet/product"), params, useGlobalLoader);
}

export async function DeletePricingSheet(
  params: IDeletePricingSheet,
  useGlobalLoader: boolean,
): Promise<IPricingSheetRes> {
  return await APIDelete(APIUrl(AdminType.FacilityAdmin, "/tee-sheet/pricing-sheet"), params, useGlobalLoader);
}

export async function PostDuplicatePricingSheet(
  params: IDuplicatePricingSheet,
  useGlobalLoader: boolean,
): Promise<IPricingSheetRes> {
  return await APIPost(APIUrl(AdminType.FacilityAdmin, "/tee-sheet/pricing-sheet/duplicate"), params, useGlobalLoader);
}
